"use client";

import { Page } from "@/types/navigation";
import { createContext, useContext, useDeferredValue } from "react";

const NavigationContext = createContext<{
  navigations: Page[];
}>({
  navigations: [],
});

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};

export default function NavigationProvider({
  children,
  data,
}: React.PropsWithChildren<{
  data: Page[];
}>) {
  const dataValue = useDeferredValue(data);
  return (
    <NavigationContext.Provider value={{ navigations: dataValue }}>
      {children}
    </NavigationContext.Provider>
  );
}
